import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BoardHomeComponent } from './pages/board-home/board-home.component';
import { FilesComponent } from './pages/files/files.component';
import { AboutComponent } from './pages/about/about.component';
import { HelpComponent } from './pages/help/help.component';
import { BoardComponent } from './board.component';
import { BoardAccessGuard } from './guards/board-access.guard';
import { AdminGuard } from './guards/admin.guard';
import { DataEntryComponent } from './pages/data-entry/data-entry.component';
import { MyTablesPageComponent } from './pages/my-tables/my-tables-page.component';
import { CustomViewsComponent } from './pages/custom-views/custom-views.component';

const routes: Routes = [
  {
    path: '',
    component: BoardComponent,
    // Runs after MsalGuard on the parent /dashboard route, so the user is
    // already authenticated. Synchronous — redirects to /select-app when no
    // application has been resolved yet.
    canActivate: [BoardAccessGuard],
    children: [
      {
        path: 'home',
        component: BoardHomeComponent
      },
      {
        path: 'data-entry',
        component: DataEntryComponent
      },
      {
        path: 'my-tables',
        component: MyTablesPageComponent
      },
      {
        path: 'custom-views',
        component: CustomViewsComponent
      },
      {
        path: 'files',
        component: FilesComponent
      },
      {
        path: 'about',
        component: AboutComponent
      },
      // {
      //   path: 'admin',
      //   component: AdminComponent
      // },
      {
        path: 'admin',
        canActivate: [AdminGuard],
        loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'help',
        component: HelpComponent
      },
      // Default child route for /dashboard
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      // Wildcard route to catch /dashboard/xyz and redirect to /dashboard/home
      { path: '**', redirectTo: 'home' },
    ],
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BoardRoutingModule { }
